var _rect, _rect2, _rect3, _rect4, _rect5, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWomen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 420,
    height: 260,
    viewBox: "0 0 420 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 420,
    height: 260,
    rx: 22,
    fill: "#f2f9f7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 70,
    width: 140,
    height: 140,
    rx: 18,
    fill: "#ffffff",
    stroke: "#c9e3df",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 95,
    width: 90,
    height: 12,
    rx: 6,
    fill: "#0f766e",
    opacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 120,
    width: 70,
    height: 10,
    rx: 5,
    fill: "#f59e0b",
    opacity: 0.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 145,
    width: 100,
    height: 10,
    rx: 5,
    fill: "#0f766e",
    opacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 120,
    r: 60,
    fill: "#0f766e",
    opacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260 190h120",
    stroke: "#f59e0b",
    strokeWidth: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomen);
export default __webpack_public_path__ + "static/media/women.3f41e75d77f99917bbce9488e0a65ec1.svg";
export { ForwardRef as ReactComponent };